/**
 * Faelles indlejring af vores to quizzer.
 *
 * Afloeser den inline-kode der ligger i main-article-behandling-by.liquid, og
 * er generisk: en blok fortaeller selv hvilken quiz den hoerer til via
 * data-guide-prefix ("skinguide" eller "phguide") og data-guide-base.
 *
 * Kontrakten er den samme for begge quizzer:
 *   <prefix>-height         iframen fortaeller sin hoejde
 *   <prefix>-open-overlay   brugeren trykkede start, aabn quizzen i fuld skaerm
 *   <prefix>-close-overlay  quizzen er faerdig eller lukket indefra
 *
 * Fire ting den goer bedre end forlaegget:
 *
 * 1. Origin-check paa message. Den gamle kode accepterede beskeder fra enhver
 *    afsender. Artikelsider har baade app-embeds og YouTube-iframes, og de
 *    kunne alle tvinge en fuldskaerms-modal frem.
 * 2. Kun een overlay ad gangen, globalt. Ellers kan body.style.overflow blive
 *    ryddet af den ene mens den anden stadig daekker skaermen.
 * 3. Lytter paa shopify:section:load. Naar en indstilling aendres i Theme
 *    Editor, genindsaettes sektionens HTML via innerHTML, og scripts i den
 *    koerer ikke igen. Uden det her ville redaktoeren se en blok uden hoejde.
 * 4. Timeout paa iframen. Kommer der ingen hoejde-besked, skjules blokken, saa
 *    en adblocker ikke efterlader en tom kasse midt paa siden.
 */
(function () {
  'use strict';

  var HEIGHT_TIMEOUT = 6000;
  var blocks = [];
  var activeOverlay = null;

  /* Koeen er startet af den inline-lytter der staar i article-guide-embed.liquid,
     foer iframen. Vi overtager den her og saetter klar, saa den holder op med
     at gemme. Findes den ikke (fx hvis assettet bruges et andet sted),
     opretter vi den selv. */
  var g = window.__cosmoGuide || (window.__cosmoGuide = { msgs: [], klar: false });
  var venter = g.msgs;
  g.klar = true;

  function originOf(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.protocol + '//' + a.host;
  }

  /* PostHog findes foerst efter Cookiebot-samtykke, og maaling maa aldrig
     kunne vaelte siden. Derfor baade guard og try/catch. */
  function track(event, block, extra) {
    try {
      if (!window.posthog || !window.posthog.capture) return;
      var props = {
        guide: block.prefix,
        page_url: location.pathname,
        blog: block.el.getAttribute('data-guide-blog') || ''
      };
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
        }
      }
      window.posthog.capture(event, props);
    } catch (e) {}
  }

  function escHandler(e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeOverlay();
  }

  function closeOverlay() {
    if (!activeOverlay) return;
    document.removeEventListener('keydown', escHandler);
    if (activeOverlay.parentNode) activeOverlay.parentNode.removeChild(activeOverlay);
    activeOverlay = null;
    document.body.style.overflow = '';
  }

  function openOverlay(block) {
    if (activeOverlay) return;

    var overlay = document.createElement('div');
    overlay.className = 'cosmo-guide-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', block.label);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'cosmo-guide-overlay__close';
    closeBtn.innerHTML = '&times;';
    closeBtn.setAttribute('aria-label', 'Luk');
    closeBtn.addEventListener('click', closeOverlay);

    var frame = document.createElement('iframe');
    frame.className = 'cosmo-guide-overlay__frame';
    frame.src = block.base + '/?embed=true&overlay=true&page=' + encodeURIComponent(block.page);
    frame.title = block.label;

    overlay.appendChild(closeBtn);
    overlay.appendChild(frame);
    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) closeOverlay();
    });

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', escHandler);
    activeOverlay = overlay;
    closeBtn.focus();
  }

  window.addEventListener('message', function (e) {
    if (!e.data || typeof e.data.type !== 'string') return;

    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      /* Origin-checken er hele pointen: kun den quiz blokken selv peger paa
         maa styre hoejde og overlay. */
      if (e.origin !== block.origin) continue;
      if (e.data.type.indexOf(block.prefix + '-') !== 0) continue;
      anvend(block, e.data);
      return;
    }

    /* Ingen blok kendte afsenderen endnu. Quizzen sender sin hoejde EEN gang
       naar den mounter, og den besked kan naa frem foer vi har registreret
       blokken. Uden det her gemmested var hoejden tabt for altid, og blokken
       stod tilbage paa sin minimumshoejde. */
    if (venter.length < 20) venter.push({ origin: e.origin, data: e.data });
  });

  function anvend(block, data) {
    var kind = data.type.slice(block.prefix.length + 1);

    if (kind === 'height') {
      var h = parseInt(data.height, 10);
      if (h > 0) {
        /* Hoejden saettes praecis som meldt, aldrig med luft oveni.
           Quizzen maaler document.documentElement.scrollHeight, og den
           vaerdi er aldrig mindre end iframens egen hoejde. Laegger man bare
           to pixel til, maaler quizzen de to pixel, sender tallet tilbage, og
           blokken vokser i det uendelige. Doedbaandet nedenfor er der af
           samme grund: en afrunding frem og tilbage kan starte samme loekke. */
        var nu = parseInt(block.frame.style.height, 10) || 0;
        if (Math.abs(h - nu) > 2) {
          block.frame.style.height = h + 'px';
        }
        block.gotHeight = true;
        block.el.removeAttribute('data-guide-pending');
      }
    } else if (kind === 'open-overlay') {
      track('guide_open', block, { entry: 'inline' });
      openOverlay(block);
    } else if (kind === 'close-overlay') {
      closeOverlay();
    }
  }

  function register(el) {
    if (el.getAttribute('data-guide-ready') === '1') return;
    var frame = el.querySelector('[data-guide-frame]');
    var base = el.getAttribute('data-guide-base');
    if (!frame || !base) return;

    var block = {
      el: el,
      frame: frame,
      prefix: el.getAttribute('data-guide-prefix') || '',
      base: base.replace(/\/+$/, ''),
      origin: originOf(base),
      page: el.getAttribute('data-guide-page') || location.href,
      label: frame.getAttribute('title') || 'Cosmo guide',
      gotHeight: false
    };
    el.setAttribute('data-guide-ready', '1');
    blocks.push(block);

    /* Beskeder der naaede frem foer blokken var registreret, spilles af i den
       raekkefoelge de kom, saa den nyeste hoejde staar til sidst.

       Kun hoejder spilles af. En gemt open-overlay ville kunne aabne en modal
       laenge efter at brugeren trykkede, og det er ikke noget vi vil have til
       at ske af sig selv. */
    var rest = [];
    for (var v = 0; v < venter.length; v++) {
      var m = venter[v];
      var mit = m.origin === block.origin && m.data.type === block.prefix + '-height';
      if (mit) {
        anvend(block, m.data);
      } else {
        rest.push(m);
      }
    }
    venter = rest;

    /* Timeouten maa foerst starte naar iframen faktisk er hentet. Den er
       lazy-loaded og sidder langt nede paa siden, saa en nedtaelling fra
       sideindlaesning ville skjule blokken for alle der laeser artiklen
       faerdig i mere end seks sekunder. */
    frame.addEventListener('load', function () {
      window.setTimeout(function () {
        if (block.gotHeight) return;
        block.el.style.display = 'none';
      }, HEIGHT_TIMEOUT);
    });

    /* Hvor mange faar overhovedet blokken at se. Uden det kan "ingen bruger
       guiden" ikke skilles fra "ingen naaede ned til den". */
    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          track('guide_view', block, { entry: 'inline' });
          io.disconnect();
          return;
        }
      }, { threshold: 0.4 });
      io.observe(el);
    }
  }

  function init(root) {
    var found = (root || document).querySelectorAll('[data-guide-embed]');
    for (var i = 0; i < found.length; i++) register(found[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
